import type { CursorPage, MutationResult } from '../../api/contract';
import { createRepositoryToken } from '../../data/RepositoryProvider';
import type {
  AcknowledgeExceptionInput,
  CreateReconciliationRunInput,
  ReconciliationException,
  ReconciliationExceptionDetail,
  ReconciliationExceptionQuery,
  ReconciliationRun,
  ReconciliationRunDetail,
  ReconciliationRunQuery,
  ResolveExceptionInput,
} from './types';

export interface ReconciliationRepository {
  listRuns(
    query: ReconciliationRunQuery,
    signal: AbortSignal,
  ): Promise<CursorPage<ReconciliationRun>>;
  createRun(
    input: CreateReconciliationRunInput,
    idempotencyKey: string,
  ): Promise<MutationResult<ReconciliationRun>>;
  getRun(runId: string, signal: AbortSignal): Promise<ReconciliationRunDetail>;
  listExceptions(
    query: ReconciliationExceptionQuery,
    signal: AbortSignal,
  ): Promise<CursorPage<ReconciliationException>>;
  getException(exceptionId: string, signal: AbortSignal): Promise<ReconciliationExceptionDetail>;
  resolveException(
    exceptionId: string,
    input: ResolveExceptionInput,
    idempotencyKey: string,
  ): Promise<MutationResult<ReconciliationExceptionDetail>>;
  acknowledgeException(
    exceptionId: string,
    input: AcknowledgeExceptionInput,
    idempotencyKey: string,
  ): Promise<MutationResult<ReconciliationExceptionDetail>>;
}

export const reconciliationRepositoryToken =
  createRepositoryToken<ReconciliationRepository>('reconciliation');

export const defaultRunQuery = Object.freeze<ReconciliationRunQuery>({
  cursor: '',
  pageSize: 50,
  filters: { type: '', trigger: '', phase: '', partnerId: '', requestedFrom: '', requestedTo: '' },
});

export const defaultExceptionQuery = Object.freeze<ReconciliationExceptionQuery>({
  cursor: '',
  pageSize: 50,
  filters: {
    status: '',
    severity: '',
    type: '',
    entityType: '',
    entityId: '',
    partnerId: '',
    detectedFrom: '',
    detectedTo: '',
  },
});
